// The one newsletter sign-up every form calls — the footer, the Newsletter section and
// the promo popup all post to the same list, and all three must name the subscriber
// to the ad pixels the same way. A fourth form that calls api.submitForm directly
// would sign people up and never tell the pixels who they were.

import { api } from "./api"
import { identifyBuyer } from "./tracking"

/** Subscribes an email; rejects when the server did not store it. `website` is the
 *  honeypot, sent as the form holds it: a filled one is a bot, which the server
 *  silently drops — and which is therefore never named to the pixels either. */
export async function subscribeNewsletter(email: string, website: string): Promise<void> {
  await api.submitForm("newsletter", { email, website })
  if (!website) identifyBuyer({ email })
}
